import React, { useState } from "react";
import { MdInsertComment } from "react-icons/md";
import AttachmentPopover from "../../../pages/employee_details/InvestmentsAndProofs/components/AttachmentPopover";
import ApprovalField from "./ApprovalField";
import AddressModal from "./AddressModal";

const HouseRentSection = ({
  houseRentData = [],
  attachments,
  onFileSelect,
  onAddMoreAttachments,
  onRemoveAttachment,
  onOpenImage,
  openPopoverKey,
  setOpenPopoverKey,
  onCommentClick,
  onApproval,
  onRejection,
  isApproving,
  isRejecting,
}) => {
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  if (!houseRentData || houseRentData.length === 0) return null;

  // Calculate months difference
  const calculateMonthsDifference = (fromDate, toDate) => {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const yearDiff = to.getFullYear() - from.getFullYear();
    const monthDiff = to.getMonth() - from.getMonth();
    return yearDiff * 12 + monthDiff + 1;
  };

  const handleViewAddress = (rent) => {
    setSelectedAddress(rent);
    setIsAddressModalOpen(true);
  };

  return (
    <>
      <AddressModal
        isOpen={isAddressModalOpen}
        onClose={() => setIsAddressModalOpen(false)}
        address={selectedAddress?.address}
        landlordName={selectedAddress?.landlord_name}
        landlordPan={selectedAddress?.landlord_pan}
      />

      <p className="text-lg mx-3 font-semibold">House Rent Paid Details</p>
      <p className="mx-3 mt-1 mb-4 text-sm">
        Declared Amount: ₹
        {houseRentData
          .reduce((total, rent) => {
            return total + parseFloat(rent.rent_amount);
          }, 0)
          .toLocaleString()} | Approved Amount: ₹
        {houseRentData
          .reduce((total, rent) => total + parseFloat(rent.amount_approved || 0), 0)
          .toLocaleString()}
      </p>
      {houseRentData.map((rent, index) => {
        const months = calculateMonthsDifference(rent.from_date, rent.to_date);
        const totalAmount = parseFloat(rent.rent_amount) * months;
        const fromDate = new Date(rent.from_date);
        const toDate = new Date(rent.to_date);
        const period = `${fromDate.toLocaleDateString('en-GB', { 
          month: 'short', 
          year: 'numeric' 
        })} - ${toDate.toLocaleDateString('en-GB', { 
          month: 'short', 
          year: 'numeric' 
        })}`;

        return (
          <div key={rent.house_rent_id} className="flex items-center mx-3 my-3">
            <div className="flex-no-grow-no-shrink px-1.5 w-[28.4%]">
              <p>{period}</p>
              <p className="mt-1 text-neutral-600 text-sm">
                Landlord Details: {rent.landlord_name} ({rent.landlord_pan})
              </p>
              <button
                onClick={() => handleViewAddress(rent)}
                className="text-blue-500 mt-1 cursor-pointer hover:underline text-sm hover:text-blue-700 transition-colors"
              >
                View Address
              </button>
            </div>
            <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%]">
              <p className="text-right text-sm">
                ₹{parseFloat(rent.rent_amount).toLocaleString()} /mo
              </p>
              <p className="text-neutral-400 text-sm text-right">
                (Total ₹{totalAmount.toLocaleString()})
              </p>
            </div>
            <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%] grid place-items-center">
              <AttachmentPopover
                attachmentKey={`house-rent-${index}`}
                attachments={attachments}
                onFileSelect={() =>
                  onFileSelect(
                    `house-rent-${index}`,
                    { house_rent_id: rent.house_rent_id },
                    rent.document_count
                  )
                }
                onAddMoreAttachments={onAddMoreAttachments}
                onRemoveAttachment={onRemoveAttachment}
                onOpenImage={onOpenImage}
                openPopoverKey={openPopoverKey}
                setOpenPopoverKey={setOpenPopoverKey}
                documentCount={rent.document_count}
              />
            </div>
            <div className="flex-no-grow-no-shrink px-1.5 w-[14.2%] grid place-items-center">
              <button
                onClick={() =>
                  onCommentClick(`house-rent-${index}`, {
                    house_rent_id: rent.house_rent_id,
                  })
                }
                className="flex items-center"
              >
                <MdInsertComment className="w-5 h-5 text-neutral-600" />
                {rent.comment_count > 0 && (
                  <span className="ml-1 text-xs text-gray-600">
                    {rent.comment_count}
                  </span>
                )}
              </button>
            </div>
            <ApprovalField
              approvedAmount={rent.amount_approved}
              actualAmount={totalAmount}
              onApproval={onApproval}
              onRejection={onRejection}
              approvalParams={{ house_rent_id: rent.house_rent_id }}
              isApproving={isApproving}
              isRejecting={isRejecting}
              status={rent.status}
            />
          </div>
        );
      })}
      <hr className="my-5 mx-3" />
    </>
  );
};

export default HouseRentSection;
